module.exports = __webpack_public_path__ + "img/pure.0a49d174.jpg";